import { Component, ChangeDetectorRef, Input, OnInit, Output, EventEmitter, SimpleChange, ElementRef, ViewChild, NgZone, ChangeDetectionStrategy, Injector, OnDestroy } from '@angular/core';
import { FormGroup, Validators } from '@angular/forms';
import { QuestionControlService } from './question-control.service';
import { QuestionBase } from './models/question-base.model';
import { FormService } from './form.service';
import { fromEvent, Subject, Subscription, takeUntil } from 'rxjs';
import { FieldGroup } from './models/field-group.model';
import { AuthenticationService } from '../../shared/services/authentication.service';
import { AppService } from '../../shared/services/app.service';
import { CommunicationService } from '../../services/communication.service';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseService } from '../../shared/services/base.service';
import { UtilService } from '../../services/util.service';
import { StorageService } from '../../shared/services/storage.service';

import { AlertsService } from '../../services/alerts.service';
import { ViewportScroller } from '@angular/common';
import { LoaderService } from '../../services/loader.service';
import get from 'lodash-es/get';
import { RolePermissionService } from '../../shared/services/role-permission.service';
import { CommonService } from '../../services/common.service';
import { HttpParams } from '@angular/common/http';
import { BookmarksComponent } from '../bookmarks/bookmarks.component';
import { QrCodeScannerComponent } from '../qr-code-reader/qr-code-scanner.component';
import { AbhaPatientRegisterComponent } from '../abha-patient-register/abha-patient-register.component';
import { DialogModalSize } from '../dialog/dialog-ref';
import { nextDay } from 'date-fns';
import { AsideBarService } from '../../services/asideBar.service';
@Component({
    selector: 'dhs-form',
    templateUrl: './form.component.html',
    styleUrls: ['./form.component.css'],
    providers: [QuestionControlService, FormService],
    standalone: false
})
export class FormComponent implements OnInit ,OnDestroy{
  private static _accSeq = 0;

  @Input() bookmarks: any;
  accUid = 'u' + (FormComponent._accSeq++);
  @Output() bookmarkEvent: EventEmitter<any> = new EventEmitter();
  // @HostListener('onSubmit')
  validIn: boolean = false; //this decided wheathet to show validation error messages
  @Input() form: FormGroup;
  //@Input() change: any;
  @Input() fieldGroup: any = []; //this provides form fields
  @Input() formtype: string = ''; //this decides wheather this is popup form
  @Input() customButton: any;
  @Input() action: any;
  @Input() config: any;
  @Input() casesheet: any;
  @Input() qrCodedata: any = {};
  @Input() data: any; //this data fills the fields of the form
  public cardData: any;
  @ViewChild('bookmarkRef') bookmarkRef: BookmarksComponent;
  @Output() saveFinished: EventEmitter<any> = new EventEmitter(); //fires when form submits
  @Output() tabclicked: EventEmitter<any> = new EventEmitter(); //fires when tab chnged
  @Output() resetForm: EventEmitter<any> = new EventEmitter(); //For reseting form and calling grid again with no filter
  @Output() cancel: EventEmitter<any> = new EventEmitter();//for redirecting on cancel
  @Output() getData: EventEmitter<any> = new EventEmitter();//for outputting general configration ie. form object
  @Output() onMultiselectClose: EventEmitter<any> = new EventEmitter();//forclosing multiselect
  //@Output() valueChange: EventEmitter<any> = new EventEmitter();//for output form oject for any field changes
  clicked = false;
  multiDropDownContainer: any;
  payLoad = '';
  //@Input() progress: boolean; commented by aarti. Let me know if used anywhere
  questions: QuestionBase<any>[];
  fieldGroups: FieldGroup[];
  isInProgress: boolean = false;
  saveButton: any = [];
  private questionsSub = {};
  private optionChanged = {};
  optionTimeout: any = false;
  title: any;
  popupForm: FormGroup;
  dependentDropdown: any;
  public _currentView: String = '';
  public _currentResource: String = '';
  public _currentformData: any = "";
  blockMapping: FieldGroup[];
  currentBtnVal: any;
  activeKey: any;
  public group_type: any = '';
  submitButton: boolean = true;
  public _subscribeOption: Subscription;
  barcodeStr: string = '';
  doctorsFavourite = [] // added for favourite checkbox implementation
  @Output() questionValueChanged = new EventEmitter<any>();
  @Output() scoreValueChanged = new EventEmitter<any>();
  @Output() customEventFired = new EventEmitter<any>();
  @ViewChild('tabRef') private tabRef: ElementRef;
  @Input() decorator: any = false;
  composite_block: boolean = false;
  keyValue: any;
  formatValue: any;
  aiFill: any = { load: false };
  private clickHandler!: (event: MouseEvent) => void;
  @ViewChild('formContainer', { static: true }) formContainer!: ElementRef;
  @Input() formName: any;
  @Input() layout_name:any;
  fromRuntime: boolean = false;
  formChangeSub?: Subscription;
  private communicationSub: Subscription;
  private sub: Subscription = new Subscription();
  constructor(
    private el: ElementRef,
    private qcs: QuestionControlService,
    public utilService: UtilService,
    private formService: FormService,
    private authenticationService: AuthenticationService,
    private appService: AppService,
    public route: ActivatedRoute,
    public communicationService: CommunicationService,
    public baseService: BaseService,
    public router: Router,
    private cdr: ChangeDetectorRef,
    private storageService: StorageService,
    public alerts: AlertsService,
    private viewportScroller: ViewportScroller,
    private loader: LoaderService,
    private ngZone: NgZone,
    private rolePermissionService: RolePermissionService,
    public commonService: CommonService,
    public sessionStorage: StorageService,
    public injector: Injector,
    public asideBarService: AsideBarService
  ) {
    this.communicationSub = communicationService.changeEmitted$.subscribe(data => {
      if (data.completed != null) {
        let completed = data.completed;
        if (completed == true) {
          this.endProgress();
        }
      }
    });
    if (this.route.snapshot.data.view != undefined) {
      this._currentView = this.route.snapshot.data.view;
    }
    if (this.route.snapshot.data.resource != undefined) {
      this._currentResource = this.route.snapshot.data.resource;
    }

  }
  getClassForButton() {
    if (document.body.classList.contains('modal-open') && this.config && this.config.floating_button) {
      return 'popup-fixed-button';
    } else if (!document.body.classList.contains('modal-open') && this.config && this.config.floating_button) {
      return 'floating_button';
    }
  }

  closeDropdown(event?: any) {
   // console.log("from parent  from component =>multiselect closed")
    if (this.decorator?.onMultiSelectClose) {
      this.decorator.onMultiSelectClose(this.buildDecoratorFormObj());
  }
  }
  setAutoSave() {
    // Track dirty state
    // Register outside Angular to avoid performance hit
    if (!this.clickHandler) {
      this.ngZone.runOutsideAngular(() => {
        this.clickHandler = (event: MouseEvent) => {
          const clickedInside = this.formContainer.nativeElement.contains(event.target);
          if (!clickedInside) {
            this.ngZone.run(() => this.handleClickOutside());
          }
        };
        document.addEventListener('click', this.clickHandler, true);
      });
    }
  }

  handleClickOutside() {

    if (!this.form?.dirty) return; // No changes → no save

    if (!this.form["_manualChange"]) return;  // No changes → no save

    if (this.el.nativeElement.contains(event.target)) {
      console.log("On form Click", this.el.nativeElement.contains(event.target));
      return; // Click inside → skip
    }
    if (this.saveButton != undefined && this.saveButton.length != undefined && (this.saveButton.length === 1)) {
      this.currentBtnVal = this.saveButton[1];
    }

    this.ngZone.run(() => this.onSubmit({ fromAutoSave: true }));
  }


  getLocalstorage() {
    // const savedData = localStorage.getItem(this.formName);
    // if (savedData && !this.data) {
    //   this.data = JSON.parse(savedData);
    // }
    let mainObj = JSON.parse(sessionStorage.getItem('curr_epres_unsaved_forms') || '{}');
    if (mainObj[this.formName] != undefined && mainObj[this.formName]) {
      this.data = mainObj[this.formName];
    }

  }


  ngOnInit() {
    this.ngZone.runOutsideAngular(() => {
      window.addEventListener('scroll', this.stickTab, { passive: true });
    });

    //Auto Save implementation
    // if (this.config != undefined && this.config.autoSave != undefined && this.config.autoSave) {
    //   this.setAutoSave();
    //     this.getLocalstorage();
    // }

    //Auto Save implementation
    if (this.config != undefined && this.config.autoSave != undefined && this.config.autoSave) {
      this.getLocalstorage();
    }




    this.loader.hideSpinner();
    this.config = (this.config != undefined) ? this.config : {};
    console.log("Config ", this.config, this.data);
    if (this.config != undefined && this.config.delta_update == undefined) {
      this.config.delta_update = false;
    }
    //this.auto_fill_banner added to stop auto populate in case of edit of composite array
    if (this.config != undefined && this.config.auto_fill_banner != undefined) {
      this.formService.setAutoFillFromNanner(this.config.auto_fill_banner);
    }
    //this.showAddData added to show data in add form
    if (this.config != undefined && this.config.showAddData != undefined) {
      this.formService.setAddData(this.config.showAddData);
    }
    if (this.config != undefined && this.config.expanded_form == undefined) {
      this.config.expanded_form = true;
    }
    this.formService.questionMapping = {};
    console.log("Ui Engine field group ", this.fieldGroup);
    if (this.fieldGroup.submitButton == undefined) {
      this.submitButton = true;
    } else
      if (!this.fieldGroup.submitButton) {
        this.submitButton = false;
      } else {
        this.submitButton = true;
      }
    this.commonService.setManualChange(false);
    if (this.config != undefined && this.config.clearOnSave == undefined) {
      this.config.clearOnSave = true;//make form fields clear by default
    }
    /***
     * For Error Handling
     */
    this.throwingError();
    /**
     * For button Label
     */
    if (this.action) {
      //now not used if needed then can use
      // if (this.decorator != undefined && this.decorator.getButtonData) {
      //   this.data = {...this.data, ...this.decorator.getButtonData(this.data)};
      // }
      this.getButtonLabel(this.action);
    }

    /******** DEOCRATOR IMPLEMENTATION *******/
    if (this.decorator != undefined && this.decorator && this.decorator.init != undefined) {
      if (this.formtype == '') {
        this.decorator.setData(this.formService, this.data, this.customButton, this.saveButton);
      } else {
        this.decorator.setFormGridData(this.data, this.customButton, this.saveButton);
      }
    } else {
      this.decorator = false;
    }
    /******** DEOCRATOR IMPLEMENTATION *******/

    /**
     * For Banner 
     */
    this.checkForBanner();
    if (this.bookmarks && this.bookmarks.bookmark) {
      console.log('bookmarks', this.bookmarks)
      this.formService.conditionShow(this.bookmarks.bookmark, this.action)
    }

    // const _event = fromEvent(document, 'keypress');
    // _event.subscribe((result: any) => {
    //   console.log("event is :: ",result);
    //   if (result['key'] === "Enter") {
    //     console.log("result is :: ",result);
    //     this.autofillQrData(result.value);
    //   }
    // })



  }

  ngAfterViewInit() {
    /**** SUBSCRIBING TO CHANGE EVENT IN FORM SERVICE */
    this._subscribeOption = this.formService.getOpionChanged().subscribe((subObj) => {
      if (subObj && subObj.question != undefined) {
        var question = subObj.question;
        if (this.decorator) {
          this.decorator.optionChanged(question);
        }
        var value: any = null;
        var currentForm: any = null;
        if (this.formtype == '') {
          currentForm = this.form;
        } else {
          currentForm = this.popupForm;
        }
        if (currentForm != undefined && currentForm.controls != undefined && currentForm.controls[question.key] != undefined && currentForm.controls[question.key].value != undefined && currentForm.controls[question.key] != undefined && currentForm.controls[question.key].value) {
          value = question.options.find(x => x[question.getterKey] == question.value);
          this.onValueChanged({ val: value, question: question });
        }
        this.optionChanged[question.key] = true;
        console.log("questionquestionquestionquestionquestionquestionquestionquestion===>", question);
      }
    });
    if (this.formService.config != undefined && this.formService.config.barcode != undefined) { // if barcode available, in form config only then this condition will sastified to listen barcode 
      this.ngZone.runOutsideAngular((event) => {
        window.addEventListener('keyup', this.getBarCodeString);
      });
    }
    if (Object.keys(this.qrCodedata).length != 0) {
      this.autofillQrData(this.qrCodedata)
    }
  }

  getBarCodeString = (event) => { // this function will check datasource and call related api and fill related controls
    this.ngZone.run(() => {
      let x = document.activeElement.tagName;
      if (x && x != "BODY") {
        return false;
      }
      if (event.code != "Enter" && this.commonService.checkStrIsAlphaNumeric(event.key)) {
        this.barcodeStr += event.key;
      }
      //this.barcodeStr = "BAR0367";// hardcoded only for testing
      if (event.code == "Enter" && event.keyCode == 13) { // when Enter key will be presssed
        if (this.formService.config.barcode.datasource && this.formService.config.barcode.id && this.barcodeStr) {
          let args;
          let data = { barCode: this.barcodeStr };
          args = JSON.parse(JSON.stringify(this.formService.config.barcode.datasource.args != undefined ? this.baseService.buildDyanamicStr(this.formService.config.barcode.datasource.args, { data: data }) : ''));
          this.loader.showSpinner();
          this.sub.add(this.baseService.get(this.formService.config.barcode.datasource.query_id, args, this.formService.config.barcode.datasource.resource, this.formService.config.barcode.datasource.application).subscribe((res) => {
            console.log("Barcode response is", res);
            this.barcodeStr = "";
            if (res.errCode == -1) {
              this.alerts.error(res.message);
              this.loader.hideSpinner();
            } else {
              // Check barcode dependents and fill related controls
              this.commonService.checkBarCodeDependents(this.config, this.formService, res);
              setTimeout(() => {
                this.cdr.detectChanges();
                this.loader.hideSpinner();
              })
            }
          }, (err) => {
            this.loader.hideSpinner();
            this.barcodeStr = "";
          }))
        }
      }
    })
  }
  expandColapseForm() {
    this.loader.showSpinner();
    this.config.expanded_form = !this.config.expanded_form;
    if (this.formService != undefined && this.formService.config != undefined && this.formService.config.isTemplate) {
      if (this.fieldGroups != undefined) {
        this.fieldGroups.forEach((block, index) => {
          if (block['group_type'] != undefined && block['group_type'] == "accordian") {
            this.fieldGroups[index]['default_open'] = this.config.expanded_form;
          }
        });
        this.loader.hideSpinner();
      } else {
        this.loader.hideSpinner();
      }
    }
    else {
      if (this.formService != undefined && this.formService.blockMapping != undefined) {
        this.formService.blockMapping.forEach((block, index) => {
          if (block['group_type'] != undefined && block['group_type'] == "scroll-tab") {
            this.formService.blockMapping[index]['default_open'] = this.config.expanded_form;
          }
        })
        this.loader.hideSpinner();
      } else {
        this.loader.hideSpinner();
      }
    }
  }

  throwingError() {
    if (this.config != undefined && !this.config.delegateSave) {
      throw new Error('dhs Form component cannot work without [saveUrl]');
    }
  }

  autofillQrData(response) {
    if (this.form != undefined && this.config.QrCodeSchema) {
      Object.keys(this.config.QrCodeSchema).forEach(element => {
        if (this.form.controls[element] != undefined)
          this.form.controls[element].setValue(response[this.config.QrCodeSchema[element]]); // set value in registration in aadhar card
      });
    }
    if (this.decorator) {
      var formObj = this.buildDecoratorFormObj();
      this.decorator.QrCodeSacnnedStart(response, formObj);
    }
  }

  autofillAbhaData(response) {
    if (this.form != undefined) {
      if (this.form.controls['abdm_number'] != undefined)
        this.form.controls['abdm_number'].setValue(response.abdm_number);
      if (this.form.controls['healthId'] != undefined)
        this.form.controls['healthId'].setValue(response.healthId);
      if (this.form.controls['healthIdNumber'] != undefined)
        this.form.controls['healthIdNumber'].setValue(response.healthIdNumber);
    }
    if (this.decorator && this.decorator.AbhaVerifiedStart) {
      var formObj = this.buildDecoratorFormObj();
      this.decorator.AbhaVerifiedStart(response, formObj);
    }
  }

  checkForBanner() {
    if (this.fieldGroup.bannerJson != undefined) {
      this.getDataFromKey(this.fieldGroup.bannerJson, (res) => {
        if (res && res.result) {
          this.cardData = res;
          console.log("Card Data form ", this.cardData);
          this.getDataForForm();
        } else {
          this.getDataForForm();
        }
      });
    } else { this.getDataForForm(); }
  }
  getButtonLabel(action) {
    let permission: boolean = true;
    switch (action) {
      case 'ADD':
        if (this.customButton && this.customButton.Add) {
          for (let i = 0; i < this.customButton.Add.length; i++) {
            if (this.customButton.Add[i].permission_required != undefined && this.customButton.Add[i].permission_required) {
              permission = this.rolePermissionService.checkAccessPermission(this.customButton.Add[i].action_name, this.route.snapshot.data.resource);
              if (permission == true) {
                this.saveButton.push(this.customButton != undefined && this.customButton.Add != undefined ? this.customButton.Add[i] : [{
                  "label": "button.add",
                  "icon": "fa fa-plus"
                }])
              }
            }
            else if (this.customButton.Add[i].expression != undefined && this.customButton.Add[i].expression) {
              let item = this.data;
              let format = this.customButton.Add[i].expression
              if (item != undefined) {
                var expres = eval(format);
                if (expres) {
                  this.saveButton.push(this.customButton.Add[i])
                }
              }
            }
            else {
              this.saveButton = this.customButton != undefined && this.customButton.Add != undefined ? this.customButton.Add : [{
                "label": "button.add",
                "icon": "fa fa-plus"
              }];
            }
          }
        }
        else {
          this.saveButton = [{
            "label": "button.add",
            "icon": "fa fa-plus"
          }];
        }
        break;
      case 'MODIFY':
        var actionButton: any = [];
        if (this.customButton != undefined && this.customButton.Modify) {
          for (let i = 0; i < this.customButton.Modify.length; i++) {
            if (this.customButton.Modify[i].expression != undefined && this.customButton.Modify[i].expression) {
              let item = this.data;
              let format = this.customButton.Modify[i].expression
              if (item != undefined) {
                var expres = eval(format);
                if (expres) {
                  actionButton.push(this.customButton.Modify[i])
                }
              }
            }
            else {
              actionButton.push(this.customButton.Modify[i]);
            }
          }
        }
        else {
          actionButton = this.customButton != undefined && this.customButton.Modify != undefined ? this.customButton.Modify : [{
            "label": "button.update",
            "icon": "fa fa-check"
          }];
        }
        this.saveButton = actionButton;
        break;
      case 'VIEW':
        this.saveButton = this.customButton != undefined && this.customButton.View != undefined ? this.customButton.Modify : [{
          "label": "button.view",
          "icon": "fa fa-check"
        }];
        break;
      case 'SEARCH':
        this.saveButton = this.customButton != undefined && this.customButton.Search != undefined ? this.customButton.Search : [{
          "label": "button.apply",
          "icon": "fa fa-check"
        }];
        break;
      default:
        console.log(`Button label ${this.action} Action is not implemented.`);
    }
  }
  getDataForForm() {
    //fix for providing parent form during question build to populate dropdown option
    if (this.formtype != '') {
      this.popupForm = new FormGroup({});
      if (this.config != undefined && this.config.parentForm != undefined) {
        this.popupForm["parentForm"] = this.config.parentForm;
      }
      this.formService.setArrayForm(this.popupForm);
    }
    //fix for providing parent form during question build to populate dropdown option


    //for tabs and card
    this.formService.setCardData(this.cardData, this.config);
    this.group_type = this.fieldGroup.blocks[0].group_type != undefined ? this.fieldGroup.blocks[0].group_type : '';
    this.activeKey = this.fieldGroup.blocks[0].name != undefined ? this.fieldGroup.blocks[0].name : '';
    this.fieldGroups = this.formService.buildFormGroup(this, this.fieldGroup);
    if (this.formtype == '') {
      this.form = this.qcs.toFormGroup(this.fieldGroups, this.action);
      this.form["_manualChange"] = false;
      /******** DEOCRATOR IMPLEMENTATION *******/
      if (this.decorator) {
        this.decorator.setForm(this.form, this.action);
      }
      /******** DEOCRATOR IMPLEMENTATION *******/
      this.getData.emit({ type: 'form', obj: this.form });
      this.config.parentForm = this.form;
    } else {
      this.popupForm = this.qcs.toFormGroup(this.fieldGroups, this.action);
      this.popupForm["_manualChange"] = false;
      if (this.config != undefined && this.config.parentForm != undefined) {
        this.popupForm["parentForm"] = this.config.parentForm;
      }
      this.formService.setArrayForm(this.popupForm);
      this.getData.emit({ type: 'form', obj: this.popupForm });

    }
    this.getData.emit({ type: 'mapping', obj: this.formService.questionMapping });
    if (this.config.default_filter) {
      if (this.formtype != '') {
        this.getData.emit({ type: 'default_filter', obj: this.popupForm.getRawValue() });
      }
      else {
        if (this.action == "SEARCH") {
          this.emitAfterValueChanged()
        } else {
          this.getData.emit({ type: 'default_filter', obj: this.form.getRawValue() });
        }
      }
    }
    //set filter emit for getting the value 
    if (this.formtype != '') {
      this.getData.emit({ type: 'default_filter_val', obj: this.popupForm.getRawValue() });
    }
    else {
      this.getData.emit({ type: 'default_filter_val', obj: this.form.getRawValue() });
    }
    // if (this.refreshForm)
    //   this.refreshForm.subscribe(data => {
    //     this.data = data;
    //     this.fieldGroups = this.formService.buildFormGroup(this);
    //   })
    this.blockMapping = this.fieldGroups;
    //sets block mapping in formservice
    this.formService.setBlockMapping(this.blockMapping);
    //Commenting because onvaluechange is firing without options set in case of dropdown
    if (this.action == 'MODIFY' || this.action == 'VIEW' || this.action == 'ADD') {
      //this.fieldGroups.forEach(element => {
      //let allQuestionWithDependent = element.questions.filter(x => x['dependents']);
      if (this.formService.questionMapping != undefined && Object.keys(this.formService.questionMapping).length) {
        for (let questionKey of Object.keys(this.formService.questionMapping)) {
          let question = this.formService.questionMapping[questionKey];
          //firing updatevaluechange if the question have value and it does not depend on async data.
          if (question && ['textbox', 'radio', 'checkbox', 'inputSearch', 'numberbox', 'daterangepicker', 'timepicker', 'html-editor', 'hidden', 'composite-array', 'textarea'].indexOf((question['component'] || question['controlType'])) > -1) {
            if (question['value'] != undefined) {
              this.onValueChanged({ val: question['value'], question: question });
            }
          }

        }
      }
      //});
    }
    console.log("form is as::", this.formService.form);
    this.formService.setForm(this.form);
    if (this.form != undefined && this.action == 'SEARCH' && this.fieldGroup.filterDataFill) {
      let res = this.utilService.unflatten(this.form.getRawValue());
      this.saveFinished.emit({ result: res });
    }
    this.checkEachBlockValidity();

    /******** AI  ********/
    if (this.config?.resource_config != undefined && this.config?.resource_config?.ai != undefined && this.config?.resource_config?.ai?.form != undefined) {
      this.aiFill.load = true;
      this.aiFill.formService = this.formService;
      this.aiFill.resource_config = this.config.resource_config;
      this.aiFill.fieldGroup = this.fieldGroup;
      this.aiFill.resource = this.config.id;
      this.aiFill.formComponenet = this;
    }
    /******** AI  ********/



    this.setFormChangeSubEvent();



  }

  emitAfterValueChanged() {
    var rawValue = this.form.getRawValue();
    if (Object.keys(rawValue).length && this.config != undefined && this.config.defFilters != undefined && Array.isArray(this.config.defFilters) && this.config.defFilters.length > 0) {
      var keyToWatch = [...this.config.defFilters]
      this.watchAndEmit(keyToWatch, 0);
    } else {
      this.getData.emit({ type: 'default_filter', obj: rawValue });
    }
  }

  watchAndEmit(keyToWatch, time) {
    var totalTimeToWatch = 5000;
    var timerTime = 200;
    if (this.optionTimeout) {
      clearTimeout(this.optionTimeout);
    }
    this.optionTimeout = setTimeout(() => {
      if (time >= totalTimeToWatch) {
        this.getData.emit({ type: 'default_filter', obj: this.form.getRawValue() });
      } else {
        for (let index = keyToWatch.length - 1; index >= 0; index--) {
          let singleKey = keyToWatch[index];
          if (this.optionChanged[singleKey] != undefined) {
            keyToWatch.splice(index, 1);
          }
        }
        if (keyToWatch.length == 0) {
          this.getData.emit({ type: 'default_filter', obj: this.form.getRawValue() });
        } else {
          this.watchAndEmit(keyToWatch, time + timerTime);
        }
      }
    }, timerTime)
  }


  cancelButtonClick() {
    if (this.route.snapshot.queryParams.hasOwnProperty('returnUrl') && this.route.snapshot.queryParams.hasOwnProperty('tab')) {
      window.location.reload();
    } else if (this.route.snapshot.queryParams.hasOwnProperty('returnUrl')) {
      this.router.navigateByUrl(this.route.snapshot.queryParams.returnUrl);
    } else if ((this.route.snapshot.data.view != undefined || this.route.snapshot.data.resource != undefined) && (this.route.snapshot.data.view != undefined && this.route.snapshot.data.view != "")) {
      let current = (this.route.snapshot.data.view == undefined) ? this.route.snapshot.data.resource : this.route.snapshot.data.view;
      const url = '/' + this.appService.getApplication() + '/' + current + '/list';
      this.router.navigate([url]);
    }
    else {
      this.cancel.emit();
    }
    /******** DEOCRATOR IMPLEMENTATION *******/
    if (this.decorator) {
      var submitRes = this.decorator.afterSubmitReqSuccess();
      if (!submitRes) {
        return;
      }
    }
  }
  resetFormClick() {
    this.getData.emit({ type: 'changePage', page: 0 });
    if (this.formtype != '') {
      this.popupForm.reset();
    } else {
      this.form.reset();
    }
    this.data = '';
    this.checkForBanner();
    this.resetForm.emit(true);
  }
  ngOnDestroy() {
      window.removeEventListener('scroll', this.stickTab);
      window.removeEventListener('keyup', this.getBarCodeString); // ← unconditional
      
      if (this.optionTimeout) {
        clearTimeout(this.optionTimeout);
        this.optionTimeout = null;
      }
    
      this.sub.unsubscribe();
    
      if (this.fieldGroup?.blocks?.length) {
        for (let fieldg of this.fieldGroup.blocks) {
          for (let field of fieldg.fields) {
            if (this.questionsSub[field.key]) {
              this.questionsSub[field.key].unsubscribe();
            }
          }
        }
      }
    
      if (this._subscribeOption?.unsubscribe) {
        this._subscribeOption.unsubscribe();
      }
    
      if (this.decorator && this.formtype == "") {
        this.decorator.destroy();
      }
    
      if (this.action != 'SEARCH') {
        this.storageService.removeData('setValueInForm', (localData) => { });
      }
    
      this.removeOutsideClickListener();
      this.destroyVCSub();
    
      if (this.communicationSub) {
        this.communicationSub.unsubscribe();

      this.asideBarService.isAsideOpen = false;
  }
}

  destroyVCSub() {
    if (this.formChangeSub) {
      this.formChangeSub.unsubscribe();
    }
  }

  removeOutsideClickListener() {
    if (this.clickHandler) {
      document.removeEventListener('click', this.clickHandler, true);
      this.clickHandler = null;
      console.log('Outside click listener removed');
    }
  }

  // formReset(){
  //   this
  //   CompositeArrayComponent
  // }
  checkEachBlockValidity() {
    if (this.fieldGroups == undefined) { // if fieldsgroup not avilable ne need to check validity
      return;
    }
    try {
      this.formService.loopBlocks(JSON.parse(JSON.stringify(this.fieldGroups)), this.fieldGroups, 0, (fieldGroups) => {
        //console.log("this.fieldGroups", fieldGroups);
        if (fieldGroups) {
          this.fieldGroups = fieldGroups;

          this.blockMapping = this.fieldGroups;
          if (!this.submitButton) {
            var submit: any = this.isFormValid();
            //console.log("Submit is ",submit);
            if (submit)
              this.submitButton = true;
            else
              this.submitButton = false;
          }
        }
      });
    }
    catch (err) {//do noyhing
    }

  }
  activeTab(key?, event?) {
    this.activeKey = key;
  }

  isFormValid() {
    //if form is valid then true
    var Arr = [];
    console.log("this.fieldGroups ::", this.fieldGroups);
    for (let i = 0; i < this.fieldGroups.length; i++) {
      Arr.push(this.fieldGroups[i]['valid'])
    }
    console.log("Arr is :: ", Arr);
    if (Arr.includes(false)) {
      return false;
    } else {
      return true;
    }
  }
  public navigateToSection(elementId: string, blockId) {
    this.openScrollBox(elementId, blockId, "menu-tab");
    this.activeKey = elementId;
    let el = document.getElementById(elementId);
    el.scrollIntoView();
    if (this.config.expanded_form) {
      window.scroll({ top: el.offsetTop, behavior: "smooth" });
    } else {
      // console.log("Top ",el.getBoundingClientRect().top);
      window.scroll({ top: el.getBoundingClientRect().top - 60, behavior: "smooth" });
    }
    //this.viewportScroller.scrollToAnchor(elementId);
    // window.location.hash = '';
    // window.location.hash = section;
  }
  openScrollBox(name, blockId, type?) {
    this.activeKey = name;
    if (!this.config.expanded_form) {
      if (this.formService != undefined && this.formService.blockMapping != undefined) {
        this.formService.blockMapping.forEach((block, index) => {
          if (block['group_type'] != undefined && block['group_type'] == "scroll-tab" && block['block_id'] == blockId) {
            if (this.formService.blockMapping[index]['default_open'] == true)
              this.formService.blockMapping[index]['default_open'] = false;
            else
              this.formService.blockMapping[index]['default_open'] = true;
          } else if (type == undefined) {
            this.formService.blockMapping[index]['default_open'] = false;
          }
        })
      }
    } else {
      if (this.formService != undefined && this.formService.blockMapping != undefined) {
        this.formService.blockMapping.forEach((block, index) => {
          if (block['group_type'] != undefined && block['group_type'] == "scroll-tab" && block['block_id'] == blockId && this.formService.blockMapping[index]['default_open'] && type == undefined) {
            this.formService.blockMapping[index]['default_open'] = false;
          } else if (block['group_type'] != undefined && block['group_type'] == "scroll-tab" && block['block_id'] == blockId && !this.formService.blockMapping[index]['default_open']) {
            this.formService.blockMapping[index]['default_open'] = true;
          }
        })
      }
    }
  }

  setConfig(event) {
    if (event?.config?.add_fav == true)
      this.config.add_fav = true;
    else
      this.config.add_fav = false;
  }

  /**
   * Submits the form as draft when the aside bar is being closed.
   * Finds the draft button config from saveButton[], sets it as currentBtnVal,
   * and calls onSubmit() so the full decorator + payload pipeline runs normally.
   * Called directly from AppAsideComponent.closeAsideBar() when user confirms draft save.
   */
  submitAsDraft(callback) {
    if (!this.saveButton || !Array.isArray(this.saveButton)) {
      console.error('No save buttons configured – cannot submit as draft.');
      return;
    }
    const draftBtn = this.saveButton.find(
      (btn: any) => btn?.status === 'draft' && !btn?.previewPrintURL
    );
    if (!draftBtn) {
      console.error('No draft button found in saveButton[] – cannot submit as draft.');
      return;
    }
    this.currentBtnVal = draftBtn;
    this.onSubmit();
    callback(true);
  }

  onSubmit(e?) {
    /******** DEOCRATOR IMPLEMENTATION *******/
    if (this.decorator) {
      var validationRes = this.decorator.beforeSubmitValidation({ currentForm: this.popupForm != undefined && this.popupForm ? this.popupForm : this.form, currentBtnVal: this.currentBtnVal }, cb => {
        if (cb) {
          this.formSubmitEvent(e);
        }
      });
      if (!validationRes) {
        return;
      }
      else {
        this.formSubmitEvent(e);
      }
    } else {
      this.formSubmitEvent(e);
    }
    /******** DEOCRATOR IMPLEMENTATION *******/
    //validIn is used to trigger class of validation at form questions  
  }

  tabclick(event) {
    if (this.form && !this.form['_manualChange'] && (this.form['_multimanualChange'] == undefined || !this.form['_multimanualChange']))
      this.tabclicked.emit(event);
    else {
      var dialogRef = this.baseService.modalService.confirmCustomBtn('CONFIRM', 'Do you want to save or skip the form?', '', { cancel: "SKIP", ok: "SAVE", cancelFunction: 'hide' }, true);
      this.sub.add(dialogRef.subscribe(result => {
        if (result == null) { }
        else if (result) {
          let c_btn = {
            "action_name": "skip_tab",
            "action": "save",
            "aside_type": event.resource ? 'resource' : 'template',
            "tooltip": event.resource ? event.resource : event.templateId,
            "type": "submit"
          }
          this.onSubmit(c_btn);
        } else {
          this.tabclicked.emit(event);
        }
      },
        () => { }));
    }
  }

  formSubmitEvent(e?) {
    this.config['invalidForm'] = false;
    if (this.currentBtnVal && this.currentBtnVal.noValidation == true) {
      for (const key of Object.keys(this.form.controls)) {
        this.form.controls[key].clearValidators()
        this.form.controls[key].setErrors(null);
        this.form.controls[key].setValidators(null);
      }
    }
    this.checkEachBlockValidity();
    const invalidControl = this.el.nativeElement.querySelector('.ng-invalid');
    if (invalidControl) {
      this.validIn = true;
    }
    if (this.fieldGroups != undefined && this.fieldGroups.length != undefined) {
      for (let i = 0; i < this.fieldGroups.length; i++) {
        console.log("Not Valid ", this.fieldGroups[i]);
        // this code need to be rectify for temporary purpose
        if (this.fieldGroups[i].questions.length > 0) {
          let hidden = this.fieldGroups[i].questions.find(val => {
            return val.key == "standard_codes" && val.controlType == 'hidden';
          });
          if (hidden != undefined && (hidden.value == undefined || hidden.value == '') && this.form && this.form.controls && this.form.controls.standard_codes) {
            this.form.controls.standard_codes.setValue([]);
          }
          if (this.fieldGroups[i].questions[0].hasOwnProperty('controlType')) {
            if (this.fieldGroups[i].questions[0]['controlType'] == 'hidden') {
              if (this.fieldGroup.blocks[i] != null && this.fieldGroup.blocks[i].fields[0].objectData) {
                this.objectData(this.fieldGroups[i].questions[0]);
              }
            }
          }
        }
        // this code need to be rectify for  temporary purpose
        if (this.fieldGroups[i].hasOwnProperty('valid') && !this.fieldGroups[i]['valid']) {
          console.log("Not Valid Inside", this.fieldGroups[i]);
          if (this.fieldGroups[i].questions[0].hasOwnProperty('controlType') && this.fieldGroups[i].questions[0]['controlType'] == 'composite-array') {
            if (this.fieldGroups[i].questions[0]['value'].length > 0) {
              this.fieldGroups[i]['valid'] = true;
            } else { return; }
          } else if (!this.fieldGroups[i]['visible']) {
            this.fieldGroups[i]['valid'] = true;
          } else if (this.fieldGroups[i]['group_type'] == 'tab') {
            this.activeKey = this.fieldGroups[i]['name'];
            return;
          }
          else if (this.fieldGroups[i]['group_type'] == 'accordian') {
            let a = this.el.nativeElement.getElementsByClassName(this.fieldGroups[i]['name']);
            for (let cl of a) {
              cl.classList.add('show');
            }
            // HCL Confusion removed
            // if (this.currentBtnVal.action_name == "next") { //for e-prescription move to next without saving reusult if invalid form
            //   let obj = { currentBtnVal: this.currentBtnVal };
            //   this.saveFinished.emit(obj);
            // }
            return;
          }
          else {
            //HCL Confusion removed
            // if (this.currentBtnVal != undefined && this.currentBtnVal.action_name != undefined && this.currentBtnVal.action_name == "next") { //for e-prescription move to next without saving reusult if invalid form
            //   let obj = { currentBtnVal: this.currentBtnVal };
            //   this.saveFinished.emit(obj);
            // }
            if (e != undefined && e.fromAutoSave != undefined && e.fromAutoSave) {
              const proceed = confirm(
                "You haven’t filled all the required fields.\n\n" +
                "Click OK to proceed, or Cancel to go back and fill the pending ones."
              );

              if (proceed) {
                localStorage.setItem(this.formName, JSON.stringify(this.utilService.unflatten(this.form.getRawValue())));
                // Save filled fields and proceed
                this.removeOutsideClickListener();
              } else {
                // Let the user go back and complete form
                console.log('User chose to fill pending fields');
              }
            }
            if (e != undefined && e.fromPres != undefined && e.fromPres) {
              this.config['invalidForm'] = true;
            }
            return;
          }
        }
      }
    }

    this.removesessionstorage();

    // Identify paginated composite-array fields
    const paginatedCompositeFields: string[] = [];
    if (this.action == 'MODIFY') {
      this.blockMapping.forEach(block => {
        block.questions.forEach((question: any) => {
          if (question.controlType === 'composite-array' && question.pagination_enabled) {
            paginatedCompositeFields.push(question.key);
          }
        });
      });
    }
    if (this.formtype != '') {
      let result: any;
      result = this.utilService.unflatten(this.popupForm.getRawValue());
      result = this.formService.filterValuesBasedOnFieldStatus(JSON.parse(JSON.stringify(result)));//it will remove the field whose status is not visible
      if (this.formService?.config?.isTemplate && (result.templateId != undefined || result.template_id != undefined))
        this.setTemplateMetadataInResult(result);//set template keys data if not set in form
      // console.log("Result of Composite Array is ",result);

      // this.submitButton = true;
      this.popupForm.clearValidators();
      this.saveFinished.emit({ result: result, currentBtnVal: this.currentBtnVal });
      if (this.config.clearOnSave) {//when filter don't reset the form(it should be done by configuration)
        this.popupForm.reset();
        this.checkForBanner(); // for reseting the form again
      }
      this.validIn = false;
    }
    if (this.form != undefined && this.form.valid != undefined && this.isFormValid()) {
      let result: any;
      if (this.formtype == '') {
        /**
         * Raw value added to send disable keys
         */
        result = this.utilService.unflatten(this.form.getRawValue());
      } else {
        result = this.utilService.unflatten(this.popupForm.getRawValue());
      }
      result = this.formService.filterValuesBasedOnFieldStatus(JSON.parse(JSON.stringify(result)));//it will remove the field whose status is not visible
      result = this.formService.attachSelectedItemsToResult(result);
      if (this.formService?.config?.isTemplate && (result.templateId != undefined || result.template_id != undefined))
        this.setTemplateMetadataInResult(result);//set template keys data if not set in form

      // Remove paginated composite-array fields from result
      if (this.action == 'MODIFY'){
        paginatedCompositeFields.forEach(key => {
          if (result.hasOwnProperty(key)) {
            delete result[key];
          }
        });
      }
      if (this.config.add_fav) {
        if(this.form.controls['fav_templateId'] && this.form.controls['fav_templateId']['question_component'] && this.form.controls['fav_templateId']['question_component'].question.options){
          let abc = this.form.controls['fav_templateId']['question_component'].question.options.find(x=>x.templateId == this.form.controls.templateId.value);
          if(abc == undefined)
            result.isRelay = true;
          else
            result.isRelay = false;
        }else
          result.isRelay = false;
      }
      if (!this.config.delegateSave) {
        this.startProgress();
      } else {
        console.log("Save Data Array", result);
        this.startProgress();
        if (this.action == 'ADD') {
          if (this.route.snapshot.params.hasOwnProperty('foreign_id') && this.route.snapshot.data.hasOwnProperty('foreign_id')) { // adding key in formData if forign data is required
            var forignKey = this.route.snapshot.data.foreign_id;
            result[forignKey] = this.route.snapshot.params.foreign_id;
          }
        }
        console.log(this.formService.form, 'this.formService.form');

        if (this.config != undefined && this.config.tag_data != undefined && this.config.tag_data) {
          result['tag_data'] = this.config.tag_data;
        }
        else {
          try {
            if (this.data != undefined && this.data.tag_data != undefined && result['tag_data'] != undefined && result['tag_data']) {
              try {
                if (result['tag_data'].length != undefined && result['tag_data'].length > 0) {
                  for (let item of this.data.tag_data) {
                    if (item['key_name'] != undefined && item['key_value_code'] && item['key_value_display'] != undefined && result['tag_data'].find(x => x.key_name == item['key_name'] && x.key_value_code == item['key_value_code'] && x.key_value_display == item['key_value_display'])) {
                      //do nothing
                    }
                    else {
                      result['tag_data'].push(item);
                    }
                  }
                }
                else if (result['tag_data'] != undefined && result['tag_data'].length != undefined) {
                  result['tag_data'].push(this.data.tag_data);
                }
              } catch (error) { }
            }
            else if (this.data != undefined && this.data.tag_data != undefined && !result['tag_data']) {
              result['tag_data'] = [];
              try {
                if ((typeof (this.data.tag_data) == "string")) {
                  this.data.tag_data = JSON.parse(this.data.tag_data);
                }
              } catch (error) { }
              result['tag_data'] = [...result['tag_data'], ...this.data.tag_data]
            }
          } catch (error) { }
        }
        /******** DEOCRATOR IMPLEMENTATION *******/
        if (this.decorator) {
          var submitRes = this.decorator.beforeOnSubmit(result, this.currentBtnVal);
        //  var closeMultiselect=this.decorator.onMultiSelectClose(this.onDropDownClose,e, this.buildDecoratorFormObj())
          if (!submitRes) {
            return;
          }
        }
        /******** DEOCRATOR IMPLEMENTATION *******/

        let obj = { result: result, currentBtnVal: this.currentBtnVal };

        // when favourite is to be added 
        if (this.config.relayInfo != undefined && this.config.relayInfo) {
          this.relayCall(obj);
        }
        if (e) {
          obj.currentBtnVal = e;
        }
        this.saveFinished.emit(obj);
        if (this.config.clearOnSave) {//when filter don't reset the form(it should be done by configuration)
          this.form.reset();
          this.checkForBanner(); // for reseting the form again
        }
        this.validIn = false;
      }
    }
    if (this.fieldGroup.submitButton != undefined && !this.fieldGroup.submitButton && this.action != 'SEARCH') {
      this.submitButton = false;
    } else {
      this.submitButton = true;
    }
  }


  removesessionstorage() {
    try {
      let mainObj = JSON.parse(sessionStorage.getItem('curr_epres_unsaved_forms') || '{}');

      if(mainObj!=undefined && mainObj[this.formName]){
        delete mainObj[this.formName];
        sessionStorage.setItem('curr_epres_unsaved_forms', JSON.stringify(mainObj));
      }
    } catch (error) {

    }
  }


  relayCall(obj) {
    try {// map data from form to favourite
      let item = this.form.value; // data for IP
      let formItem = this.formService.cardData.data; // data for OP
      let lastExpression = "";
      if (eval(this.config.relayInfo.expression)) {
        var relayObj = this.config.relayInfo;
        obj['relayInfo'] = JSON.parse(JSON.stringify(this.config.relayInfo));
        if (this.formService.activeKey == "brandWiseMedication") {
          for (let b in item) {
            if (b.length > 19) {
              if (b.slice(0, 19) == "brandWiseMedication") {
                item[b.slice(20,)] = item[b];
                delete item[b];
              }
            }
          }
          item['allowFractionalIssue'] = item['allowFractionalIssue'] == '0' ? false : item['allowFractionalIssue'];
          item['sequence'] = item['sequence'] == '' ? null : item['sequence'];
        }
        this.sessionStorage.getData("favouritesData", (data) => { this.doctorsFavourite = data; });
        this.sessionStorage.removeData("favouritesData", () => { });
        for (let expression in relayObj.map) {
          if (expression) {
            obj['relayInfo'].map[expression] = eval(obj['relayInfo'].map[expression]);
            lastExpression = expression;
          }
        }

        if (this.doctorsFavourite) {
          if (this.doctorsFavourite.length > 0) {
            var i = 0;
            while (i < obj['relayInfo'].map[lastExpression].length) {
              for (let j = 0; j < this.doctorsFavourite.length; j++) {
                if (obj['relayInfo'].map[lastExpression][i].itemName && this.doctorsFavourite[j].itemName && obj['relayInfo'].map[lastExpression][i].itemName == this.doctorsFavourite[j].itemName) {
                  obj['relayInfo'].map[lastExpression].splice(i, 1);
                  i--; break;
                }
                else if (obj['relayInfo'].map[lastExpression][i].name && this.doctorsFavourite[j].name && obj['relayInfo'].map[lastExpression][i].name == this.doctorsFavourite[j].name) {
                  obj['relayInfo'].map[lastExpression].splice(i, 1);
                  i--; break;
                }
                else if (obj['relayInfo'].map[lastExpression][i].text && this.doctorsFavourite[j].text && obj['relayInfo'].map[lastExpression][i].text == this.doctorsFavourite[j].text) {
                  obj['relayInfo'].map[lastExpression].splice(i, 1);
                  i--; break;
                }
                else if (obj['relayInfo'].map[lastExpression][i].favourite_name && this.doctorsFavourite[j].favourite_name && obj['relayInfo'].map[lastExpression][i].favourite_name == this.doctorsFavourite[j].favourite_name) {
                  obj['relayInfo'].map[lastExpression].splice(i, 1);
                  i--; break;
                }
              }
              i++;
            }
          }
        }
        if (obj['relayInfo'].map[lastExpression].length == 0) {
          console.log("Alredy in fav");
          delete obj['relayInfo'];
        }
      }
    } catch (error) {
      console.log("Error RelayInfo");
    }
  }

  favouriteList(data) {
    //console.log("Favourite Data", data);
    if (data && data != undefined && data.length > 0) {
      this.doctorsFavourite = data;
      if (this.doctorsFavourite && this.doctorsFavourite.length > 0) {
        this.sessionStorage.setData("favouritesData", this.doctorsFavourite, () => { })
      }
    }
  }

  objectData(field) {
    let values;
    if (field['value']) {
      values = Object.values(field['value']);
    }
    if (!values && this.form != undefined) {
      this.form.controls[field.key].setValue({});
    }
  }

  scoreEvent(scoreData) {
    this.scoreValueChanged.emit(scoreData);
  }

  toFormGroup(fieldGroup: any, result = {}, prefix: any = false, isChildGroup = false, isAssignment = false) {
    let group: any = {};
    let childGroups: any = [];
    var newPrefix = false;
    if (fieldGroup.name != undefined) {
      newPrefix = fieldGroup.name;
    } else if (fieldGroup.resource != undefined) {
      newPrefix = fieldGroup.resource;
    }
    if (prefix) {
      prefix = prefix + '__' + newPrefix;
    } else {
      prefix = newPrefix;
    }

    if (this.isArray(fieldGroup)) {
      for (let index = 0; index < fieldGroup.length; index++) {
        var formg = fieldGroup[index];
        group = this.parseFormGroup(formg, group, result, prefix, isChildGroup, isAssignment);
      }
    } else {
      for (let key in fieldGroup) {
        var formg = fieldGroup[key];
        group = this.parseFormGroup(formg, group, result, prefix, isChildGroup, isAssignment);
      }
    }
    return group;
  }


  parseFormGroup(formg: any, group, result, prefix: any = false, isChildGroup, isAssignment = false) {
    var name = formg['name'];
    for (let key in formg.questions) {
      var question = formg.questions[key];
      if (this.isArray(question)) {
        const questionName = (question as any)?.name;
        if (questionName != undefined) {
          var blockGroup = this.toFormGroup(question, result, prefix, true, isAssignment);
          group[questionName] = blockGroup.group;
        } else {
          var blockGroup = this.toFormGroup(question, result, prefix, true, isAssignment);
          group[blockGroup.name] = blockGroup.group;
        }
      } else {
        if (question.key) {
          if (prefix) {
            var prefixAr = prefix.split('__');
            if (prefixAr.length) {
              var ref = group;
              for (key in prefixAr) {
                if (ref[prefixAr[key]] != undefined) {
                  ref[prefixAr[key]] = {};
                  var ref = ref[prefixAr[key]];
                }
              }
              var newKey = question.key.replace(prefix + '__', '');
              ref[newKey] = (result[question.key] != undefined) ? result[question.key] : '';
            } else {
              group[question.key] = (result[question.key] != undefined) ? result[question.key] : '';
            }
          } else {
            group[question.key] = (result[question.key] != undefined) ? result[question.key] : '';
          }
        }

      }
    };
    if (isChildGroup) {
      return { name: name, group: group };
    } else {
      return group;
    }
  }

  assignComplexFormValue(formData, name) {
    if (name.indexOf('__') > -1) {
      return name.split('__').reduce((o, i) => o[i], formData);
    } else {
      if (formData[name] != undefined) {
        return '';
      } else {
        return formData[name];
      }
    }
  }

  startProgress() {
    // this.isInProgress = true;
  }

  endProgress() {
    this.isInProgress = false;
  }

  getParamValueQueryString(paramName, callback) {
    if (this.route.snapshot.queryParams.key == undefined) {
      const url = window.location.href;
      let paramValue;
      if (url.includes('?')) {
        const httpParams = new HttpParams({ fromString: url.split('?')[1] });
        paramValue = httpParams.get(paramName);
      }
      if (paramValue != null)
        callback(paramValue);
      else
        callback(false);
    } else {
      callback(this.route.snapshot.queryParams.key)
    }
  }

  getDataFromKey(bannerJson, callback) {
    if (bannerJson.hasOwnProperty('key') && bannerJson?.callQueryParamsApi == undefined) {
      //get Tags and data to send in form
      this.getTagsData(bannerJson.key, (res) => {
        callback(res);
      });
    } else {
      this.getParamValueQueryString('key', (response) => {
        if (response) {
          var id = response;
          var bannerArgs = '';
          if (this.route.snapshot.queryParams.query_params)
            bannerArgs = this.route.snapshot.queryParams.query_params;
          else if (bannerJson.datasource['args'] == undefined)
            bannerArgs = "id:" + id;
          else if (bannerJson.datasource['args'] != undefined && bannerJson.datasource['args'].includes('!!!')) {
            bannerArgs = this.baseService.buildDyanamicStr(bannerJson.datasource['args'], { data: this.route.snapshot.queryParams })
          } else {
            bannerArgs = bannerJson.datasource['args'] + ",id:" + id;
          }

          this.sub.add(this.baseService.get(bannerJson.datasource.query_id, bannerArgs, bannerJson.datasource.resource, bannerJson.datasource.application).subscribe((data: any) => {
            if (data.errCode == -1) {
              this.alerts.error(data.message);
              callback(false);
            } else {
              //get Tags and data to send in form
              if (data.resource && data.resource.length > 0) {
                this.config['patientDataById'] = data.resource[0];
                this.getTagsData(data.resource[0], (res) => {
                  callback(res);
                });
              } else {
                callback({ "data": data.resource != undefined && data.resource[0] != undefined ? data.resource[0] : {}, "result": true });
              }
            }
          }, error => {
            callback(false);
          }));
        } else {
          callback(false);
        }
      });
    }
  }

  getTagsData(data, callback) {
    //restrict_get_banner means the screen's own banner datasource is the source of truth. patient-layout
    //already honours it for the banner itself; without the same check here the encounter GET_BANNER_DATA
    //response is merged on top of it and overwrites the form values with the wrong record.
    if (this.fieldGroup != undefined && this.fieldGroup.bannerJson != undefined && this.fieldGroup.bannerJson.datasource != undefined
      && this.fieldGroup.bannerJson.datasource.restrict_get_banner) {
      this.config['tag_data'] = data != undefined && data['tag_data'] != undefined && data['tag_data'] ? data['tag_data'] : false;
      callback({ "data": data, "result": true });
      return;
    }
    let args = ''
    if (data.uhId != undefined && data.encounter_id != undefined) {
      args = "uhId:" + data.uhId + ",encounter_id:" + data.encounter_id;
    } else if (data.uhId != undefined && data.orderId != undefined && data.orderId != '') {
      args = "uhId:" + data.uhId + ",orderId:" + data.orderId;
    } else if (data.uhId != undefined && data.serviceRequestId != undefined && data.serviceRequestId != '') {
      args = "uhId:" + data.uhId + ",serviceRequestId:" + data.serviceRequestId;
    } else if (data.uhId != undefined && data.admissionId != undefined && data.admissionId != '') {
      args = "uhId:" + data.uhId + ",orderId:" + data.admissionId;
    } else {
      args = "uhId:" + data.uhId;
    }
    this.sub.add(this.baseService.get("GET_BANNER_DATA", args, "encounter", "adt").subscribe(
      (res: any) => {
        if (res.errCode == 0 && res.resource.length > 0) {
          let arr = ["g_creation_time", "id", "g_created_by_id", "g_created_by_name", "g_modified_by_id", "g_modified_by_name", "g_creation_time", "g_modify_time", "g_soft_delete"]
          var misc_data = res.resource[0];
          for (let i = 0; i < arr.length; i++) {
            if (misc_data[arr[i]])
              delete misc_data[arr[i]];
          }
          data = { ...data, ...misc_data };
          //setting tags info for flow
          this.config['tag_data'] = data['tag_data'] != undefined && data['tag_data'] ? data['tag_data'] : false;
        }
        callback({ "data": data, "result": true });
      }));
  }



  isArray(obj) {
    return obj instanceof Array;
  }
  // public unsavedData() {
  //   this.unsavedChanges.next(true);
  // }
  // public onActionClicked(e: any) {
  //   this.actionClicked.next(e)
  // }


  ngOnChanges(changes: { [propKey: string]: SimpleChange }) {
    if (changes['data'] && this.fieldGroups) {
      this.fieldGroups = this.formService.buildFormGroup(this, this.fieldGroup);
      this.blockMapping = this.fieldGroups;
      if (this.formtype == '') {
        this.formService.form = this.qcs.toFormGroup(this.fieldGroups, this.action);
      } else {
        this.formService.popupForm = this.qcs.toFormGroup(this.fieldGroups, this.action);
      }
    }

    if (changes.config && changes.config.currentValue && changes.config.currentValue.reset != undefined && changes.config.previousValue != undefined && changes.config.previousValue.reset && changes.config.previousValue.reset != changes.config.currentValue.reset) {
      this.resetOnlyForm(changes.config.currentValue);
    } else if (changes.config && changes.config.currentValue && changes.config.previousValue && changes.config.currentValue.submit != undefined && changes.config.previousValue.submit != changes.config.currentValue.submit) {
      this.onSubmit();
    }
    // if (this.refreshForm) {
    //   this.fieldGroups = this.formService.buildFormGroup(this);
    // }
  }

  resetOnlyForm(change) {
    this.form.reset();
    this.data = '';
    this.fieldGroups = this.formService.buildFormGroup(this, this.fieldGroup);
    this.form = this.qcs.toFormGroup(this.fieldGroups, this.action);
    // this.form["_manualChange"] = false;
    this.getData.emit({ type: 'form', obj: this.form });
    if (this.config.default_filter && change.quickReset) {
      this.getData.emit({ type: 'default_filter', obj: this.form.getRawValue() });
    }
  }


  private extractDictionary(dto: any, keyFieldName: string, valueFieldName: string) {
    let result;
    if (Array.isArray(dto)) {
      result = [];
      dto.forEach(el => {
        if (el.hasOwnProperty(keyFieldName)) {
          result.push({
            key: el[keyFieldName],
            value: el[valueFieldName]
          })
        }
      })
    } else {
      result = dto;
    }

    return result;
  }

  buildDecoratorFormObj() {
    return { type: this.formtype, form: (this.formtype == "") ? this.form : this.popupForm, id: (this.config != undefined && this.config.id != undefined) ? this.config.id : "main", bookmarkRef: (this.bookmarkRef != undefined ? this.bookmarkRef : undefined) };
  }
  public onValueChanged(e: any) {
    console.log("onValueChanged", e);
    /******** DEOCRATOR IMPLEMENTATION *******/
    if (this.decorator) {
      this.decorator.valueChangeStart(e, this.buildDecoratorFormObj());
    }
    /******** DEOCRATOR IMPLEMENTATION *******/

    this.config.stopPropagation = (this.config.stopPropagation != undefined) ? this.config.stopPropagation : {};

    if (e.button) {
      this.submitButton = true;
    } else if (e.button == false) {
        this.submitButton = false;
        if (e.action == 'delete' && Array.isArray(e.items) && e.items.length == 0) {
          return;
        }
        this.checkEachBlockValidity();
    }
    else {
      if (e.val != undefined) {
        let arrayVal: any = "";
        let objVal: any = "";
        let flag: boolean = false;
        if (e.question != undefined && e.question.dependents != undefined && e.question.dependents.length) {

          var currentForm = (this.formtype == '') ? this.form : this.popupForm;
          for (let index = 0; index < e.question.dependents.length; index++) {
            var dependents = e.question.dependents[index];

            /**
             * for multivalue action eg:value=[a,b],action:any(enable disable etc)
             */
            if (dependents.populate_change_empty != undefined && dependents.populate_change_empty == true && this.action != 'MODIFY' || (dependents.populate_change_empty == undefined)) {
              if (Array.isArray(dependents.value)) {
              arrayVal = dependents.value;
              let val: any = false;
              val = dependents.value.find(x => x == e.val);
              if (val || val == "") {
                dependents['value'] = val;
                flag = true;
              }
            }
            /**
             * case to handle populate fields & others
             */
            if (typeof (e.val) == "object") {
              objVal = JSON.parse(JSON.stringify(e.val));
              if (dependents.action != "populate_field") {
                e.val = e.val[e.question.getterKey];
              } else {
                if (Array.isArray(objVal) && objVal.length > 0) {
                  objVal = objVal[0]; //for populate fields we can't work with multiple value hence taking first value by default
                }
              }
            }
            if (dependents.action != undefined) {
              if (dependents.dependent_field != undefined && dependents.dependent_field != '') {

                let conditionMet = false;
                let conditionNotMet = false;
                if (typeof objVal == 'object') {
                  if (Array.isArray(objVal)) {

                    var allVals = [];
                    if (e.question != undefined && e.question.controlType != undefined && (e.question.controlType == 'searchselect')) {
                      allVals = objVal.map(a => a['text']);
                    } else {
                      allVals = objVal.map(a => a[e.question.getterKey]);
                    }

                    conditionMet = allVals.length > 0 && (dependents.value == undefined || (dependents.value != undefined && (dependents.value || dependents.value == "") && allVals.indexOf(dependents.value) > -1));

                    conditionNotMet = allVals.length == 0 || (dependents.value != undefined && (dependents.value || dependents.value == "") && allVals.indexOf(dependents.value) == -1);
                  } else {

                    var selected;
                    if (dependents.action == "populate_field") {
                      if (e.question != undefined && e.question.controlType != undefined && (e.question.controlType == 'searchselect')) {
                        if (e.question.options) {
                          if (e.question.options.find(x => x['id'] != undefined)) {
                            selected = e.question.options.find(x => x['id'] == objVal.id);
                          }
                          if (e.question.options.find(x => x['id'] == undefined)) {
                            selected = e.question.options.find(x => x[e.question.getterKey] == objVal[e.question.getterKey]);
                          }
                          if (selected && get(selected, dependents.value)) {
                            objVal = get(selected, dependents.value);
                          } else {
                            objVal = '';//value not found in options
                            continue;
                            // break;
                          }
                        } else {
                          objVal = '';//value not found in options
                          break;
                        }
                      }
                      conditionMet = (dependents.value == undefined || (dependents.value != undefined && (dependents.value || dependents.value == "") && objVal != ''));
                      conditionNotMet = (dependents.value != undefined && (dependents.value || dependents.value == "") && Object.keys(objVal).length == 0);
                    } else {

                      if (dependents.value != undefined && typeof dependents.value == 'object' && Array.isArray(dependents.value)) {
                        conditionMet = (dependents.value == undefined || ((dependents.value.length) && (objVal[e.question.getterKey] != undefined && dependents.value.indexOf(objVal[e.question.getterKey]) > -1)));
                        conditionNotMet = (dependents.value != undefined && (dependents.value.length) && (objVal[e.question.getterKey] != undefined && dependents.value.indexOf(objVal[e.question.getterKey]) == -1));
                      } else {
                        conditionMet = (dependents.value == undefined || (dependents.value != undefined && (dependents.value || dependents.value == "") && (objVal[e.question.getterKey] != undefined && objVal[e.question.getterKey] == dependents.value)));
                        conditionNotMet = (dependents.value != undefined && (dependents.value || dependents.value == "") && (objVal[e.question.getterKey] != undefined && objVal[e.question.getterKey] != dependents.value));
                      }
                    }
                  }
                } else { //when value is string
                  //when dependent value is array
                  if (dependents.value != undefined && typeof dependents.value == 'object' && Array.isArray(dependents.value)) {
                    conditionMet = ((dependents.value == undefined && e.val != '') || (dependents.value != undefined && (dependents.value || dependents.value == "") && dependents.value.indexOf(e.val) > -1));
                    conditionNotMet = (dependents.value == undefined && e.val == '') || (dependents.value != undefined && (dependents.value || dependents.value == "") && dependents.value.indexOf(e.val) == -1);
                  } else {
                    //when dependent value is string
                    conditionMet = ((dependents.value == undefined && e.val != '') || (dependents.populate_change_empty == true && e.val == '') || (dependents.value != undefined && (dependents.value || dependents.value == "") && dependents.value == e.val));
                    conditionNotMet = (dependents.value == undefined && e.val == '') || (dependents.value != undefined && (dependents.value || dependents.value == "") && dependents.value != e.val);
                  }

                }
                var question = this.formService.questionMapping[dependents.dependent_field];
                //adding this to set manual change in dependents
                if (e.question != undefined && e.question['_manualChange'] != undefined && e.question['_manualChange']) {
                  if (question != undefined)
                    question['_manualChange'] = true;
                }

                if (!question) {
                  if (e.question.key && e.question.key.includes('.')) {//for composite
                    if (e.question.key.lastIndexOf('.') > - 1) {
                      question = this.formService.questionMapping[e.question.key.substring(0, e.question.key.lastIndexOf('.')) + '.' + dependents.dependent_field];
                    }
                  }
                }
                /*** HANDLING COMPOISITE ARRAY DEPENDENT ***/
                if (!question && dependents.composite_block != undefined && this.formService.compositeQuestionMapping[dependents.composite_block] != undefined && this.formService.compositeQuestionMapping[dependents.composite_block][dependents.dependent_field] != undefined && this.formService.compositeFormMapping[dependents.composite_block] != undefined) {
                  question = this.formService.compositeQuestionMapping[dependents.composite_block][dependents.dependent_field];
                  currentForm = this.formService.compositeFormMapping[dependents.composite_block];
                  this.composite_block = true;
                }
                /*** HANDLING COMPOISITE ARRAY DEPENDENT ***/
                if (conditionMet && question) {

                  switch (dependents.action) {
                    case 'change_value':
                      if (question.controlType == "inclusion-exclusion") {
                        question.reload = new Date().getTime();
                      } else {
                        var cloneDependant = JSON.parse(JSON.stringify(dependents));
                        if (cloneDependant.args != undefined && e.val) {
                          cloneDependant.args = cloneDependant.args.replace('!!!getterKey!!!', e.val);
                        }
                        else if (cloneDependant.search != undefined && e.val) {
                          cloneDependant.search = cloneDependant.search.replace('!!!getterKey!!!', e.val);
                        }
                        if (cloneDependant.filter != undefined && e.val) {
                          cloneDependant.filter = cloneDependant.filter.replace('!!!getterKey!!!', e.val);
                        } else if (cloneDependant.composite_args != undefined && cloneDependant.composite_args.length > 0) {

                          cloneDependant.args = this.setArgs(cloneDependant);
                        }
                        var field: any = {};
                        field.datasource = cloneDependant;
                        field.getterKey = question.getterKey;
                        field.getterValue = question.getterValue;
                        field.req_keys = question.req_keys;
                        //question.stop_propagation added for for stoping populate 

                        if (this.config.stopPropagation[e.question.key] == undefined) {
                          this.formService.setdropdownOptions(field, question, this);
                          if (currentForm['_manualChange'] == undefined || !currentForm['_manualChange']) {
                            this.onValueChanged({ question: question, val: e.val });
                          } else {
                            if (question.key == 'primary_address.city') {
                              console.log("stopPropagation");
                            }
                            if (!question['stopProp']) {
                              currentForm.controls[question.key].setValue("");
                              question.value = "";
                              this.onValueChanged({ question: question, val: "" });
                            }
                            // currentForm.controls[question.key].setValue("");
                            // question.value = "";
                            // this.onValueChanged({ question: question, val: "" });
                          }
                        } else {
                          this.formService.setdropdownOptions(field, question, this);
                        }



                      }
                      break;
                    case 'visible':
                      this.setFieldVisibiltiy(question, true, currentForm);
                      break;
                    case 'search_select':
                      var cloneDependant = JSON.parse(JSON.stringify(dependents));
                      if (cloneDependant.args != undefined && e.val) {
                        cloneDependant.args = cloneDependant.args.replace('!!!getterKey!!!', e.val);
                      }
                      question.datasource = cloneDependant;
                      break;
                    case 'validate':
                      if (this.form && this.form.controls[question.key] != undefined && this.form.controls[question.key].setValidators != undefined) {
                        this.form.controls[question.key].setValidators(null);
                        //this.form.controls[question.key].setValue('');
                      }
                      else if (this.popupForm && this.popupForm.controls[question.key] != undefined && this.popupForm.controls[question.key].setValidators != undefined) {
                        this.popupForm.controls[question.key].setValidators(null);
                        //this.popupForm.controls[question.key].setValue('');
                      }
                      question.required = false;
                      this.setValidation(question, dependents);
                      break;
                    case 'invisible':
                      this.setFieldVisibiltiy(question, false, currentForm);
                      break;
                    case 'enable':
                      this.setFieldEnabled(question, false);
                      break;
                    case 'populate_field':
                      if (((this.action == 'ADD' || this.action == 'SEARCH') && !this.popupForm) || (this.action == 'MODIFY' && currentForm['_manualChange'] != undefined && currentForm['_manualChange'] && !this.popupForm) || (this.popupForm && this.config.compositearray_action != undefined && this.config.compositearray_action == 'ADD') || (this.popupForm && this.config.compositearray_action != undefined && this.config.compositearray_action == 'MODIFY' && currentForm['_manualChange'] != undefined && currentForm['_manualChange'])) {
                        if (question.controlType == 'composite-array' || question.controlType == 'editable-table') {
                          if (e.val != undefined && typeof e.val == 'object') {
                            this.setarray(e, question);
                          }
                        }
                        else if ((typeof (e.val) == "object")) {
                          if (e.question != undefined && e.question.controlType != undefined && (e.question.controlType == 'searchselect')) {
                            if (selected) {
                              this.setvalue(question, dependents, selected);
                            } else {
                              this.setvalue(question, dependents, objVal);
                            }
                          } else {
                            this.setvalue(question, dependents, e.val);
                          }
                        } else {
                          this.setvalue(question, dependents, e.val);
                        }
                        console.log("populate_field", dependents);
                      }


                      //this.onValueChanged({ question: question, val: e.val[dependents.value] });
                      break;
                    case 'disable':
                      this.setFieldDisabled(question, false);
                      if (this.form) {
                        this.form.controls[question.key].setValue("");
                      }
                      break;
                    case 'change_val_form_with_grid':
                      ///////////////////////
                      var cloneDependant = JSON.parse(JSON.stringify(dependents));
                      cloneDependant.args = this.setArgs(cloneDependant);
                      question.dataResource['args'] = this.setArgs(cloneDependant);
                      break;
                    default:
                      //do nothing
                      break;
                  }
                } else if (conditionNotMet && question) {
                  switch (dependents.action) {
                    case 'change_value':
                      if (question.controlType == "inclusion-exclusion") {
                        question.reload = new Date().getTime();
                      } else {
                        var cloneDependant: any = {};
                        cloneDependant.possible_value = [];
                        var field: any = {};
                        field.datasource = cloneDependant;
                        field.req_keys = question.req_keys;
                        this.formService.setdropdownOptions(field, question, this);
                        if (currentForm['_manualChange'] == undefined || !currentForm['_manualChange']) {
                          this.onValueChanged({ question: question, val: '' });
                        } else {
                          currentForm.controls[question.key].setValue("");
                          question.value = "";
                          this.onValueChanged({ question: question, val: "" });
                        }
                      }


                      break;
                    case 'populate_field':
                      if (question.controlType == 'composite-array') {
                        if (e.val != undefined && typeof e.val == 'object') {
                          this.setarray(e, question);//we might have to set null value here also
                        }

                      } else {
                        //load deafult if value exists or set null
                        let val = (this.data != undefined && this.data[question.key] != undefined && this.action == "ADD") ? this.data[question.key] : (question.value != undefined && (currentForm['_manualChange'] == undefined || !currentForm['_manualChange'])) ? question.value : '';
                        this.setvalue(question, dependents, val);
                      }
                      //no need to set value
                      // else if ((typeof (e.val) == "object") || ((typeof (e.val) == "string") && this.action == "ADD")) {
                      //   if (e.question != undefined && e.question.controlType != undefined && (e.question.controlType == 'searchselect')) {
                      //     this.setvalue(question, dependents, null);
                      //   } else {
                      //     this.setvalue(question, dependents, null);
                      //   }

                      // }
                      // this.onValueChanged({ question: question, val: e.val[dependents.value] });
                      break;
                    case 'search_select':
                      var cloneDependant = JSON.parse(JSON.stringify(dependents));
                      if (cloneDependant.args != undefined && e.val) {
                        cloneDependant.args = cloneDependant.args.replace('!!!getterKey!!!', e.val);
                      }
                      question.datasource = cloneDependant;
                      break;
                    case 'visible':
                      this.setFieldVisibiltiy(question, false, currentForm);
                      break;
                    case 'invisible':
                      this.setFieldVisibiltiy(question, true, currentForm);
                      break;
                    case 'enable':
                      this.setFieldEnabled(question, true);
                      break;
                    case 'disable':
                      this.setFieldDisabled(question, true);
                      break;
                    case 'change_val_form_with_grid':
                      ///////////////////////
                      var cloneDependant = JSON.parse(JSON.stringify(dependents));
                      cloneDependant.args = this.setArgs(cloneDependant);
                      break;
                    case 'validate':
                      //this.setValidation(question, dependents);                     
                      break;
                    default:
                      //do nothing
                      break;
                  }
                }
              }
              else if (dependents.dependent_block != "" || dependents.dependent_block != undefined) {
                var block;
                try {
                  block = this.formService.findBlock(dependents.dependent_block, this.blockMapping, JSON.parse(JSON.stringify(this.blockMapping)), 0);
                } catch (error) {
                  //
                }
                if (block) {
                  switch (dependents.action) {
                    case 'visible':
                      //if its dependent value is string then it should be equeal if array then it should be present 
                      if ((typeof dependents['value'] != 'object' && dependents['value'] == e.val) || (typeof dependents['value'] == 'object' && Array.isArray(dependents['value']) && dependents['value'].indexOf(e.val) > -1)) {
                        this.setBlockVisibiltiy(block, true);
                      }
                      else {
                        this.setBlockVisibiltiy(block, false);
                      }
                      // })

                      break;
                    case 'invisible':
                      if ((typeof dependents['value'] != 'object' && dependents['value'] == e.val) || (typeof dependents['value'] == 'object' && Array.isArray(dependents['value']) && dependents['value'].indexOf(e.val) > -1)) {
                        this.setBlockVisibiltiy(block, false);
                      }
                      else {
                        this.setBlockVisibiltiy(block, true);
                      }
                      break;
                    case 'enable':
                      if ((typeof dependents['value'] != 'object' && dependents['value'] == e.val) || (typeof dependents['value'] == 'object' && Array.isArray(dependents['value']) && dependents['value'].indexOf(e.val) > -1)) {
                        this.setBlockDisablity(block, false);
                      } else {
                        this.setBlockDisablity(block, true);
                      }
                      break;
                    case 'disable':
                      if ((typeof dependents['value'] != 'object' && dependents['value'] == e.val) || (typeof dependents['value'] == 'object' && Array.isArray(dependents['value']) && dependents['value'].indexOf(e.val) > -1)) {
                        this.setBlockDisablity(block, true);
                      }
                      else {
                        this.setBlockDisablity(block, false);
                      }
                      break;
                    default:
                      //do nothing
                      break;
                  }
                }
              }
            }
            if (flag) {
              dependents['value'] = arrayVal;
              flag = false;
            }
              if (dependents.action != "populate_field" && objVal != "") {
                e.val = objVal;
              }
            }
          }
        }
      }
      /******** DEOCRATOR IMPLEMENTATION *******/
      if (this.decorator) {
        this.decorator.valueChangeEnd(e, this.buildDecoratorFormObj());
      }
      /******** DEOCRATOR IMPLEMENTATION *******/
      // debugger;
      this.questionValueChanged.emit({ question: e, form: this.form });
      this.checkEachBlockValidity();
    }
    if (e && e.question != null && this.form && this.form['_manualChange']) {
      console.log("Before formula call", e.question);
      this.formService.calculatefield(e);
    }
    // var result = this.utilService.unflatten(this.form.getRawValue());
    // result = this.formService.filterValuesBasedOnFieldStatus(JSON.parse(JSON.stringify(result)));
    // this.valueChange.emit({ res: result }); has to remove
  }

  setValidation(question?, dependents?) {
    var form = (this.form) ? this.form : this.popupForm;
    if (dependents.validations != undefined) {
      var validators: any = [];
      if (dependents.validations.pattern != undefined && dependents.validations.pattern) {
        validators.push(Validators.pattern(dependents.validations.pattern));
      }
      if (dependents.validations.required != undefined && dependents.validations.required) {
        validators.push(Validators.required);
        question.required = true;
      }

      if (validators.length) {
        form.controls[question.key].setValidators(validators);
      }
      if (form != undefined && form.controls != undefined && form.controls[question.key] != undefined && form.controls[question.key].updateValueAndValidity != undefined) {
        form.controls[question.key].updateValueAndValidity({ onlySelf: true, emitEvent: true });
      }

    }
  }

  setvalue(question, dependents, val) {
    let e: string = dependents.value;
    let q: string = question.key;
    var valToSet: any = "";
    // var valToSet = _.get(val, e);
    if (val && val[dependents.value] != undefined) {
      valToSet = val[dependents.value];
    } else if ((typeof val == 'object' && val.hasOwnProperty(dependents.value)) || (typeof val != 'object') || (typeof val == 'object' && question.controlType == "editgrid")) {
      valToSet = val;
    }
    //added for nested obj
    if (val && e && e.includes('.')) {
      valToSet = get(val, e);
    }
    //added for if type of val is array i.e in case of multiselect
    if (val && Array.isArray(val)) {
      valToSet = val;
    }
    if (this.popupForm != undefined && this.popupForm.controls != undefined && valToSet != undefined) {
      this.popupForm.controls[q].setValue(valToSet);
      if (this.popupForm.controls[q] != undefined && this.popupForm.controls[q]['question_component'] != undefined) {
        this.popupForm.controls[q]['question_component'].question.value = valToSet;
        if ((question.controlType == 'dropdown' || question.controlType == 'searchselect') && this.popupForm.controls[q]['question_component'].question != undefined && this.popupForm.controls[q]['question_component'].question.options != undefined && this.popupForm.controls[q]['question_component'].question.options.length > 0) {
          var selectedOption = this.popupForm.controls[q]['question_component'].question.options.find(x => x[question.getterKey] == question.value);
          this.popupForm.controls[q]['question_component'].updateDependentValue((selectedOption) ? selectedOption : '');
        } else {
          this.popupForm.controls[q]['question_component'].updateDependentValue(valToSet);
        }

      }
    }
    else {
      if (this.form != undefined && this.form.controls[q] != undefined && this.form.controls[q]['question_component'] != undefined && valToSet != undefined) {
        this.form.controls[q].setValue(valToSet);
        this.form.controls[q]['question_component'].question.value = valToSet;
        //for stopping the propagation of populate dependents
        if (dependents.stop_propagation != undefined && dependents.stop_propagation) {
          this.config.stopPropagation[q] = true;
        }
        if ((question.controlType == 'dropdown' || question.controlType == 'searchselect') && this.form.controls[q]['question_component'].question != undefined && this.form.controls[q]['question_component'].question.options != undefined && this.form.controls[q]['question_component'].question.options.length > 0) {
          var selectedOption = this.form.controls[q]['question_component'].question.options.find(x => x[question.getterKey] == question.value);
          this.form.controls[q]['question_component'].updateDependentValue((selectedOption) ? selectedOption : '');
        } else {
          this.form.controls[q]['question_component'].updateDependentValue(valToSet);
        }
      }
    }
  }




  setarray(e, question) {
    if (e.val) {
      //checking if value already exists
      var found = false;
      if (question.value && question.value.length) {
        var key = 'id';
        if (e.question != undefined && e.question.getterKey != undefined) {
          key = e.question.getterKey;
        }
        if (e.val != undefined && e.val[key] != undefined) {
          for (let value of question.value) {
            if (value[key] != undefined && value[key] == e.val[key]) {
              found = true;
              break;
            }
          }
        }

      }
      if (!found) {
        question.value.push(e.val);
      }
      if (this.formService.form != undefined) {
        this.formService.form.controls[question.key].setValue(question.value);
      }
      else
        this.formService.popupForm.controls[question.key].setValue(question.value);
    }

  }

  emitButtonInfo(event) {
    this.currentBtnVal = event;
  }
  //for show hide of block
  conditionShow(question) {
    if (question.conditions != undefined && question.conditions.length > 0) {
      var currentUserType = this.authenticationService.getUserType();
      var currentApplication = this.appService.getApplication();
      var disableDone = false;
      var invisibleDone = false;
      for (let i = 0; i < question.conditions.length; i++) {
        let currentConditions = question.conditions[i];
        /**** FOR APPLICATION ****/
        if (currentConditions.application != undefined) {
          if (currentConditions.application.indexOf(currentApplication) > -1) {
            if (currentConditions.action == 'disable') {
              question.disabled = true;
              disableDone = true;
            }

            if (currentConditions.action == 'invisible') {
              question.visible = false;
              invisibleDone = true;
            }
          }
        }

        /**** FOR USER TYPE ****/
        if (currentConditions.user_type != undefined) {
          if (currentConditions.user_type.indexOf(currentUserType) > -1) {
            if (!disableDone) {
              if (currentConditions.action == 'disable') {
                question.disabled = true;
                disableDone = true;
              }
            }

            if (!invisibleDone) {
              if (currentConditions.action == 'invisible') {
                question.visible = false;
                invisibleDone = true;
              }
            }
          }
        }
        /**** FOR USER TYPE ****/

        /**** FOR ACTIONS ****/
        if (currentConditions.resource_action != undefined) {
          if (currentConditions.resource_action.indexOf(this.action) > -1) {
            if (!disableDone) {
              if (currentConditions.action == 'disable') {
                question.disabled = true;
                disableDone = true;
              }
            }

            if (!invisibleDone) {
              if (currentConditions.action == 'invisible') {
                question.visible = false;
                invisibleDone = true;
              }
            }
          }
        }
        /**** FOR USER TYPE ****/
      }
    }
  }



  setArgs(value) {
    if (!value) {
      return "";
    }
    let args = [];
    for (let i = 0; i < value.composite_args.length; i++) {
      if (this.popupForm == undefined) {
        if (value.composite_args[i].type == 'dynamic' && this.form && this.form.value[value.composite_args[i].value] != undefined) {
          let val = value.composite_args[i].key + ":" + this.form.value[value.composite_args[i].value];
          args.push(val);
        } else if (!value.composite_args[i].setNull) {
          let val = value.composite_args[i].key + ":" + value.composite_args[i].value;
          args.push(val);
        }
      } else {
        //console.log("Lallalalalal ",this.form," Another one ",this.popupForm);
        //console.log("Condition Verification ",value.composite_args[i].type == 'dynamic'," Once Again ",this.popupForm.value[value.composite_args[i].value] != undefined)
        if (value.composite_args[i].type == 'dynamic' && this.popupForm && this.popupForm.value[value.composite_args[i].value] != undefined) {
          if (this.popupForm.value[value.composite_args[i].value] != "") {
            let val = value.composite_args[i].key + ":" + this.popupForm.value[value.composite_args[i].value];
            args.push(val);
          }
        } else if (!value.composite_args[i].setNull) {
          let val = value.composite_args[i].key + ":" + value.composite_args[i].value;
          args.push(val);
        }
      }

    }
    return args.join();
  }


  /****** FUNCTION TO CHANGE BLOCK AND ITS QUESTION
   * VISIBLE/INVISIBLE (it also takes care of required)
   */
  setBlockVisibiltiy(block, visibility) {
    block['visible'] = visibility;


    for (let question of block.questions) {
      // check if its a block then loop through its questions.
      if (Array.isArray(question)) {
        if (question[0].questions != undefined) {
          for (let singleQuestion of question[0]['questions']) {
            if (visibility) {
              this.setFieldVisibiltiy(singleQuestion, visibility);
            } else {
              this.setFieldVisibiltiy(singleQuestion, visibility); //it was earlier emit_change false to prevent in furhter firing dependent value bug it is removed due to bug #9961
            }
          }
        }
      }
      else {
        if (visibility) {
          this.setFieldVisibiltiy(question, visibility);
        } else {
          this.setFieldVisibiltiy(question, visibility); //it was earlier emit_change false to prevent in furhter firing dependent value bug it is removed due to bug #9961
        }
      }
    }

    this.cdr.detectChanges();//to prevent expression changed after checked error
  }

  setBlockDisablity(block, disabled) {
    block['disabled'] = disabled;
    for (let question of block.questions) {
      // check if its a block then loop through its questions.
      if (Array.isArray(question)) {
        if (question[0].questions != undefined) {
          for (let singleQuestion of question[0]['questions']) {
            if (disabled) {
              this.setFieldDisabled(singleQuestion, disabled, false);
            } else {
              this.setFieldEnabled(singleQuestion, disabled, false);
            }
          }
        }
      }
      else {
        if (disabled) {
          this.setFieldDisabled(question, disabled, false);
        } else {
          this.setFieldEnabled(question, disabled, false);
        }
      }
    }
    this.cdr.detectChanges();//to prevent expression changed after checked error
  }


  QRCodeScanForm() {
    let popobj = { data: {}, title: 'QR Code Scanner', size: DialogModalSize.Sm };
    this.sub.add(this.baseService.modalService.dialogService.open(QrCodeScannerComponent, popobj).afterClosed.subscribe(
      response => {
        if (response) {
          this.autofillQrData(response)
        }
        console.log("response is :: ", response);
      }));
  }

  AbhaAddForm() {
    let popobj = { data: {}, title: 'Add Patient by ABHA', size: DialogModalSize.Sm };
    this.sub.add(this.baseService.modalService.dialogService.open(AbhaPatientRegisterComponent, popobj).afterClosed.subscribe(
      response => {
        if (response) {
          this.autofillAbhaData(response)
        }
      }));
  }

  setFormFieldVisiblity(form, question, visibility) {
    if (form != undefined) {
      var singleControl = form.controls[question.key];
      if (form.controls[question.key] != undefined) {
        if (visibility) {
          if (question.disabled == undefined || !question.disabled) {
            singleControl.enable();
          }

          // if(question.controlType == 'numberbox'){
          //   singleControl.setValue(0);
          // }else{
          //   singleControl.setValue(null);
          // }
          if (question.required) {
            singleControl.setValidators([Validators.required]);
          }
        } else {
          singleControl.disable();
          // if(question.controlType == 'numberbox'){
          //   singleControl.setValue(0);
          // }else{
          //   singleControl.setValue(null);
          // }
          if (question.required) {
            singleControl.setValidators(null);
          }
        }
        question.visible = visibility;
      }
    }
  }

  setFieldVisibiltiy(question, visibility, compositeForm?, emit_change = true,) {
    if (this.popupForm) {
      this.setFormFieldVisiblity(this.popupForm, question, visibility);
    }
    else if (this.composite_block) {
      this.composite_block = false;
      this.setFormFieldVisiblity(compositeForm, question, visibility);
    }
    else {
      this.setFormFieldVisiblity(this.form, question, visibility);
    }
    if (emit_change && this.form != undefined && this.form && this.form.controls[question.key] != undefined && this.form.controls[question.key]['question_component'] != undefined && visibility) {
      this.form.controls[question.key]['question_component'].updateDependentValue(this.form.controls[question.key].value);
    }
    else if (emit_change && this.form != undefined && this.form && this.form.controls[question.key] != undefined && this.form.controls[question.key]['question_component'] != undefined && !visibility) {
      this.form.controls[question.key]['question_component'].updateDependentValue('');
    }
  }
  setFieldEnabled(question, disabled, emit_change = true) {
    if (this.popupForm) {
      this.setArrayEnabled(question, disabled);
    }
    else {
      if (this.form.controls[question.key] != undefined) {
        if (disabled) {
          this.form.controls[question.key].disable();
          question.disabled = true;
        } else {
          this.form.controls[question.key].enable();
          question.disabled = false;
        }
      }
      if (emit_change && this.form.controls[question.key] != undefined && this.form.controls[question.key]['question_component'] != undefined) {
        this.form.controls[question.key]['question_component'].updateDependentValue(this.form.controls[question.key].value);
      }
    }

  }
  setFieldDisabled(question, disabled, emit_change = true) {
    if (this.popupForm) {
      this.setArrayDisabled(question, disabled, emit_change);
    }
    else {
      if (this.form.controls[question.key] != undefined) {
        if (!disabled) {
          this.form.controls[question.key].disable();
          question.disabled = true;
        } else {
          this.form.controls[question.key].enable();
          question.disabled = false;
        }
      }
      if (emit_change && this.form.controls[question.key] != undefined && this.form.controls[question.key]['question_component'] != undefined) {
        this.form.controls[question.key]['question_component'].updateDependentValue(this.form.controls[question.key].value);
      }
    }
  }
  setArrayEnabled(question, disabled) {
    if (this.popupForm.controls[question.key] != undefined) {
      if (disabled) {
        this.popupForm.controls[question.key].disable();
        question.disabled = true;
      } else {
        this.popupForm.controls[question.key].enable();
        question.disabled = false;
      }
      if (this.form != undefined && this.form && this.form.controls[question.key] != undefined && this.form.controls[question.key]['question_component'] != undefined) {
        this.form.controls[question.key]['question_component'].updateDependentValue('');
      }
    }
  }
  setArrayDisabled(question, disabled, emit_change = true) {
    if (this.popupForm.controls[question.key] != undefined) {
      if (!disabled) {
        this.popupForm.controls[question.key].disable();
        question.disabled = true;
      } else {
        this.popupForm.controls[question.key].enable();
        question.disabled = false;
      }
      if (emit_change && this.form != undefined && this.form && this.form.controls[question.key] != undefined && this.form.controls[question.key]['question_component'] != undefined) {
        this.form.controls[question.key]['question_component'].updateDependentValue('');
      }
    }
  }
  customButtonEvent(event, action_name) {
    if (action_name != undefined) {
      event.action_name = action_name;
      this.saveFinished.emit({ currentBtnVal: event });
    } else
      this.saveFinished.emit(event);
    // this.customEventFired.emit({
    //   event: event,
    //   formControls: this.form.controls
    // });
  }

  bookmarkAdded(event, type) {
    if (this.popupForm != undefined && this.popupForm.controls[type] != undefined) {
      this.popupForm.controls[type].setValue([event]);
    }
    if (type != undefined && type.includes('parent__')) {
      type = type.split('parent__')[1]
      if (this.popupForm != undefined && this.popupForm['parentForm'] && this.popupForm['parentForm'].controls[type] != undefined) {
        this.popupForm['parentForm'].controls[type].setValue([event]);
      }
    }

    /******** DEOCRATOR IMPLEMENTATION *******/
    if (this.decorator) {
      var formObj = this.buildDecoratorFormObj();
      formObj.type = 'bookmark';
      this.decorator.valueChangeEnd(event, formObj);
    }
    // else
    if (this.form != undefined && type != undefined && this.bookmarks && this.bookmarks.bookmark && this.bookmarks.bookmark.not_set == undefined) {
      type.split(',').forEach(element => {
        if (this.form.controls[element] != undefined)
          this.form.controls[element].setValue(Array.isArray(event) ? event : [event]); // Array check for multiselect fav
      });
    }
  }

  getDataFn(data: any) {
    if (data.type != undefined) {
      if (data.type == "mapping" && data.obj != undefined && data.obj.id != undefined && data.obj.form != undefined) {
        this.formService.compositeQuestionMapping[data.obj.id] = data.obj.form;
      }
      if (data.type == "form" && data.obj != undefined && data.obj.id != undefined && data.obj.form != undefined) {
        this.formService.compositeFormMapping[data.obj.id] = data.obj.form;
      }
    }
    console.log("getDataFngetDataFn", this.formService);
  }

  //for scrolling tabs
  stickTab = () => {
    // let tabRef = this.el.nativeElement.querySelector('#v-pills-tab')
    if (this.tabRef != undefined && this.tabRef != null && this.tabRef.nativeElement) {
      if (this.tabRef.nativeElement.offsetHeight - 78 <= window.pageYOffset)
        this.tabRef.nativeElement.classList.add('fixedtabs')
      else
        this.tabRef.nativeElement.classList.remove('fixedtabs')
    }
  }

  showId(id, kl) {
    if (document.getElementById(id).style.display === "block") {
      document.getElementById(id).style.display = "none";
      document.getElementById(kl).classList.remove("accordion-header");
    }
    else if (document.getElementById(id).style.display === "none" || document.getElementById(id).style.display === "") {
      document.getElementById(id).style.display = "block";
      document.getElementById(kl).classList.add("accordion-header");
    }
  }
  ngDoCheck() {
    // console.log("ngdocheck form");
  }
  setTemplateField(event, blocks) {
    if (event.set_template_block) {
      let blockArr = this.fieldGroup.blocks;
      blockArr.forEach(key => {
        if (key.block_id == event.set_template_block) {
          key.fields.forEach(fieldKey => {
            fieldKey.blocks.splice(1);//remove prev temp fields on select another temp 
          })
        }
      })
      //set temp fields in mentioned block
      blockArr.every(elem => {
        if (elem.name == event.set_template_block) {
          blocks.forEach(obj => {
            obj.fields.forEach(field => {
              field['name'] = event.set_template_block + '.' + field['name'];
            });
            elem.fields[0].blocks.push(obj)
          });
          return false;
        } else return true;
      });
      blocks = blockArr;
    }
    else
      blocks.unshift(...this.fieldGroup.blocks);

    return blocks;
  }

  isBlankTemplateValue(value: any): boolean {
    return value == undefined || value === '';
  }

  firstTemplateValue(...values: any[]): any {
    return values.find(value => !this.isBlankTemplateValue(value));
  }

  getTemplateMetadata(...sources: any[]): any {
    const metadata: any = {};
    sources.filter(source => source).forEach(source => {
      const templateId = this.firstTemplateValue(metadata.templateId, source.templateId, source.template_id, source.form_template_id);
      const templateName = this.firstTemplateValue(metadata.templateName, source.templateName, source.template_name);
      const templateType = this.firstTemplateValue(metadata.templateType, source.templateType, source.template_type, source.form_template_type);
      const title = this.firstTemplateValue(metadata.title, source.title);
      const confidential = this.firstTemplateValue(metadata.confidential, source.confidential);

      metadata.templateId = templateId;
      metadata.template_id = templateId;
      metadata.templateName = templateName;
      metadata.template_name = templateName;
      metadata.templateType = templateType;
      metadata.template_type = templateType;
      metadata.title = title;
      metadata.confidential = confidential;
    });
    return metadata;
  }

  setTemplateMetadataInResult(result: any): void {
    if (!result)
      return;

    const metadata = this.getTemplateMetadata(result?.template, result, this.form?.getRawValue(), this.data);

    // If metadata keys are missing, fallback to looking up templateId question component options
    const isMetadataBlank = ['templateName', 'template_name', 'templateType', 'template_type', 'title', 'confidential'].every(key => this.isBlankTemplateValue(metadata[key]));
    if (isMetadataBlank) {
      const options = this.form?.controls?.['templateId']?.['question_component']?.question?.options;
      const targetId = result.templateId || result.template_id || metadata.templateId || metadata.template_id;
      const matched = options?.find((opt: any) => opt.form_template_id == targetId);
      if (matched) {
        const templateName = this.firstTemplateValue(metadata.templateName, matched.templateName, matched.template_name, matched.name);
        const templateType = this.firstTemplateValue(metadata.templateType, matched.templateType, matched.template_type, matched.form_template_type);
        const title = this.firstTemplateValue(metadata.title, matched.title);
        const confidential = this.firstTemplateValue(metadata.confidential, matched.confidential);

        metadata.templateName = templateName;
        metadata.template_name = templateName;
        metadata.templateType = templateType;
        metadata.template_type = templateType;
        metadata.title = title;
        metadata.confidential = confidential;
      }
    }

    [
      { key: 'templateId', value: metadata.templateId },
      { key: 'template_id', value: metadata.template_id },
      { key: 'templateName', value: metadata.templateName },
      { key: 'template_name', value: metadata.template_name },
      { key: 'templateType', value: metadata.templateType },
      { key: 'template_type', value: metadata.template_type },
      { key: 'title', value: metadata.title },
      { key: 'confidential', value: metadata.confidential }
    ].forEach(item => {
      if (result.hasOwnProperty(item.key) && !this.isBlankTemplateValue(item.value) && this.isBlankTemplateValue(result[item.key]))
        result[item.key] = item.value;
      if (result.template && result.template.hasOwnProperty(item.key) && !this.isBlankTemplateValue(item.value) && this.isBlankTemplateValue(result.template[item.key]))
        result.template[item.key] = item.value;
    });
  }

  makeDynamicQuestion(event, blocks) {
    let oldFormValue = { ...this.data, ...(this.form ? this.form.value : {}) };
    console.log("before set oldFormValue", oldFormValue);
    if (this.form) {
      //set raw value data if this.form.value is getting blank
      const raw = this.form.getRawValue();
      const templateKeys = ["templateName", "template_name", "templateType", "template_type", "templateId", "template_id", "title"];
      for (let key of templateKeys) {
        if (raw[key] !== undefined) {
          oldFormValue[key] = raw[key];
        }
      }
    }
    console.log("after set oldFormValue", oldFormValue);
    // if(oldFormValue.templateId == undefined && this.form.controls.templateId){
    //   oldFormValue.templateId = this.form.controls.templateId.value;
    // }
    this.data = JSON.parse(JSON.stringify(oldFormValue));
    if (typeof blocks == 'object')
      blocks.forEach(obj => {
        obj['template'] = true;//to check temp block
        //#198087: a saved multiselect template answer can still be a raw stringified array at this
        //point - parse it before the control is built, or it renders/saves as flattened strings
        if (obj && this.action == 'MODIFY' && Array.isArray(obj.fields)) {
          obj.fields.forEach(field => {
            if (field && field.component == 'searchselect' && !field.defaultsetting?.singleSelection) {
              if (this.data[field.name] && typeof this.data[field.name] == 'string' && this.data[field.name].trim() !== '') {
                try {
                  this.data[field.name] = JSON.parse(this.data[field.name])
                } catch (e) {
                  console.error(e);
                }
              }
            }
          });
        }
      });
    if (this.action != 'MODIFY' && (event.perserveTemplate == undefined || event.perserveTemplate == true))
      blocks = this.setTemplateField(event, blocks);
    if (this.action == 'MODIFY' && event.perserveTemplate != undefined && event.perserveTemplate == true) {
      blocks = this.setTemplateField(event, blocks);
      if (event.keys_to_remove) {
        for (let key of event.keys_to_remove)
          delete this.data[key]
      }
    }
    let newFormGroup = this.formService.buildFormGroup(this, { blocks: blocks, bannerJson: this.fieldGroup.bannerJson ? this.fieldGroup.bannerJson : '' })
    this.fieldGroups = newFormGroup
    console.log("fgs=>", this.fieldGroups);
    this.form = this.qcs.toFormGroup(this.fieldGroups, this.action);
    // #107924 set value in case when template not exist in response data and template field is visible
    if (oldFormValue && oldFormValue.templateId != undefined && oldFormValue.templateId != '' && this.form.controls && this.form.controls.templateId && (this.form.controls.templateId.value == '' || this.form.controls.templateId.value == undefined)) {
      this.form.controls.templateId.setValue(oldFormValue.templateId);

      if (oldFormValue.templateName != undefined && oldFormValue.templateName != '' && this.form.controls.templateName && (this.form.controls.templateName.value == '' || this.form.controls.templateName.value == undefined))
        this.form.controls.templateName.setValue(oldFormValue.templateName);
    }
    this.form["_manualChange"] = false;
    if (this.formService?.questionMapping && Object.keys(this.formService.questionMapping).length > 0)
      Object.keys(this.formService.questionMapping).forEach(key => {
        if (this.form.controls[key] != undefined && this.formService.questionMapping[key].controlType == 'fileuploader' && this.route && this.route['_routerState']?.snapshot.url.includes("view_clm_package_summary")) {
          this.formService.questionMapping[key]['formAction'] = 'VIEW';//183271 to hide delete and upload access
        }
      })
    console.log("check formservice", this);
    this.cdr.detectChanges()
    for (let key in oldFormValue) {
      if (this.form.controls[key] != undefined) {
        this.form.controls[key].setValue(oldFormValue[key]);
        this.data[key] = oldFormValue[key];
        setTimeout(() => {
          if (this.form.controls[key]['question_component'])
            this.onValueChanged({ val: oldFormValue[key], question: this.form.controls[key]['question_component'].question });
        })
      }
    }
    this.formService.calculatefieldAll(this.form)
    this.formService.setForm(this.form);
    if (this.decorator) {
      let decoratorClass = this.decorator.className;
      let oldDecorator = this.decorator
      this.decorator.destroy();
      this.decorator = this.baseService.initDecorator(decoratorClass, this.route, this.injector);
      if (this.decorator.setDecoratorRef)
        this.decorator.setDecoratorRef(oldDecorator)
      if (this.decorator.setData)
        this.decorator.setData(this.formService, this.data)
      if (this.decorator.setForm)
        this.decorator.setForm(this.form, this.action)
    }
    this.loader.hideSpinner();

    this.setFormChangeSubEvent();

  }
  createRuntimeQuestions(event) {
    console.log(event);
    if (event && event.data && event.data.blocks && event.data.blocks.length > 0)
      this.makeDynamicQuestion(event, event.data.blocks);
    else if (event && event.datasource) {
      let args = JSON.parse(JSON.stringify(event.datasource.args != undefined ? this.baseService.buildDyanamicStr(event.datasource.args, { data: event.data }) : ''));
      this.sub.add(this.baseService.get(event.datasource.query_id, args, event.datasource.resource, event.datasource.application).subscribe(res => {
        if (res && res.resource && res.resource.length > 0) {
          if (event.datasource.setExtraKey && this.form.controls[event.datasource.setExtraKey] && res.resource[0][event.datasource.setExtraKey])
            this.form.controls[event.datasource.setExtraKey].setValue(res.resource[0][event.datasource.setExtraKey])
          let arr = [{"key":"templateId","value":"id"}, {"key":"templateName","value":"name"}, 
            {"key":"templateType","value":"templateType"}, {"key":"title","value":"title"}, {"key":"confidential","value":"confidential"}
          ];
          arr.forEach(element => {
            if (this.form.controls[element.key]) {
              this.form.controls[element.key].setValue(res.resource[0][element.value]);
            }
          });
          if(this.form.controls['templateId'] && this.form.controls['templateId']['question_component'] && this.form.controls['templateId']['question_component'].question && this.form.controls['templateId']['question_component'].question.defaultsetting && this.form.controls['templateId']['question_component'].question.defaultsetting.defaultOpen)
            this.form.controls['templateId']['question_component'].question.defaultsetting.defaultOpen = false;
          this.fromRuntime = true;
          this.makeDynamicQuestion(event, res.resource[0].blocks);
        }
      }))
    }
    else if (!event) {
      //remove temp block on deselect temp
      let indexArr = [];
      this.fieldGroups.forEach((obj, i) => {
        if (obj['template'])
          indexArr.push(i);
      });
      if (indexArr.length > 0)
        for (var i = indexArr.length - 1; i >= 0; i--) {
          this.fieldGroups.splice(indexArr[i], 1);
        }
      this.form.controls['templateId'].setValue("");
      this.form.controls['templateName'].setValue("");
    }
    console.log("this.fieldGroups=>", this.fieldGroups);
  }

  setFormChangeSubEvent() {
    try {
      if (this.config != undefined && this.config.autoSave != undefined && this.config.autoSave) {
        if (this.formChangeSub) {
          this.formChangeSub.unsubscribe();
        }
        this.formChangeSub = this.form.valueChanges.subscribe(val => {
          let mainObj = JSON.parse(sessionStorage.getItem('curr_epres_unsaved_forms') || '{}');
          mainObj[this.formName] = val;
          sessionStorage.setItem('curr_epres_unsaved_forms', JSON.stringify(mainObj));
        });
      }
    } catch (error) {
      console.error(error);
    }
  }

}